import GlobalBtnWrapper from 'components/buttons/GlobalBtnWrapper'
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { btnHeight, btnWidth,  } from 'app/globalSettings'
import { setViewSidebar } from 'features/sidebar/sidebarSlice'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { pBtn } from 'components/main.styled'
import { useTranslation } from 'react-i18next'

export default function PrayerWallButton() {
  const { t: translate } = useTranslation()

    const dispatch = useDispatch()
    const { viewSidebar } = useSelector((state) => state.sidebar)
    const { user } = useSelector((state) => state.auth)

    const handleViewPrayerWall = () => {

        viewSidebar === "prayerWall" ?
            dispatch(setViewSidebar("none"))
            :
            dispatch(setViewSidebar("prayerWall"))

    }

    return ( 
            <PrayerWallButtonContainer
                onClick={handleViewPrayerWall}
                >
                    { viewSidebar === "prayerWall" ? 
                        (
                            <VisibilityOffIcon style={{marginRight: '5px', fontSize: '16px'}}/>
                        )
                        :
                        (
                            <FormatListBulletedIcon style={{marginRight: '5px', fontSize: '16px'}}/>
                        )
                    } 
                    <span>
                        {viewSidebar === "prayerWall" ? 
                            (
                                translate("web:general.hidePrayerWall")
                            )
                            :
                            (
                                translate("web:general.viewPrayerWall")
                            )
                        }
                    </span>
            </PrayerWallButtonContainer> 
    )
}

const PrayerWallButtonContainer = styled(pBtn)` 
    background-color: white;
    box-shadow: ${props => props.isFocused ? '0 0 5px #414141' : '0 0 10px #ccc'}; 
    &:hover{ 
        box-shadow: 0 0 5px #7a7a7a;
    }     
    @media (max-width: 768px) {
        display: none;
    }
`